import React, { useEffect } from "react";
import HeaderImage from "../../components/HeaderImage";
import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
import CollaboratingCarousel from "../../components/CollaboratingCarousel";

 export const faq = [
    {
      question: "What is Diamond Open Access publishing?",
      answer: (
        <p>
          Diamond Open Access is a scholarly publishing model that eliminates
          fees for both authors and readers. This approach ensures equitable
          access to research outputs while promoting collaborative
          knowledge-sharing and fostering inclusivity in scholarly
          communication.
        </p>
      ),
    },
    {
      question: "Why is peer review important?",
      answer: (
        <p>
          Peer review is vital for maintaining the quality, accuracy, and
          credibility of scholarly publications. It serves as a foundation for
          validating research, ensuring the information published in journals is
          reliable and accurate. Through rigorous evaluation by experts, peer
          review helps preserve the integrity of scholarly work and uphold the
          standards of research.
        </p>
      ),
    },
    {
      question: "Who can participate in COPPHA courses?",
      answer: (
        <p>
          COPPHA courses are designed for African researchers, editors,
          librarians, lecturers, public health professionals, and graduate
          students seeking to build expertise in open access publishing and peer
          review.
        </p>
      ),
    },
    {
      question: "What is the cost of the course?",
      answer: (
        <p>
          The course is free of charge for all participants, with costs fully
          covered by COPPHA.
        </p>
      ),
    },
    {
      question: "What is the duration of the course?",
      answer: (
        <p>
          The course ran for five weeks, offering a structured and immersive
          learning experience through self-paced modules and live interactive
          sessions.
        </p>
      ),
    },
    {
      question: "Who can participate in COPPHA courses?",
      answer: (
        <p>
          COPPHA courses are designed for African researchers, editors,
          librarians, lecturers, public health professionals, and graduate
          students seeking to build expertise in open access publishing and peer
          review.
        </p>
      ),
    },
    {
      question: "Who are the facilitators?",
      answer: (
        <p>
          The course was facilitated by experienced public researchers with
          expertise in peer review and scholarly publishing. They guided
          participants weekly on the course platform and live Zoom sessions.
        </p>
      ),
    },
    {
      question: "Will participants receive a certificate?",
      answer: (
        <p>
          Yes, participants who successfully completed the course received a
          certificate of completion.
        </p>
      ),
    },
  ];

const CopphaPage: React.FC = () => {
  // const [expandedFAQ, setExpandedFAQ] = useState<number | null>(null);
  // const toggleFAQ = (index: number) => {
  //   setExpandedFAQ(expandedFAQ === index ? null : index);
  // };

  useEffect(() => {
    const element = document.getElementById("coppha");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, []);


  const feedbacks = [
    {
      name: "JO",
      title: "Public Health Practitioner",
      country: "Kenya",
      feedback:
        "I joined this program knowing completely nothing about peer reviewing and am coming out with clear information about it. Thank you for making it happen. To the lecturers and hosts, thank you from the bottom of my heart. I can clearly say that I am capable of performing a peer review because of you.",
    },
    {
      name: "WV",
      title: "Lecturer",
      country: "Nigeria",
      feedback:
        "The model review assignment and the answer have been something to keep learning from. I commend the organizers and participants for their valuable inputs and for making it possible for diverse researchers and scholars to be on this space. More success in future endeavors.",
    },
    {
      name: "JN",
      title: "Lecturer and Dean",
      country: "Uganda",
      feedback:
        "The reflection forums helped to internalize the concepts and learn from others. Without a doubt, following the structured, six-step format is going to make my peer review experience a better one. This is a course I highly recommend.",
    },
    {
      name: "PW",
      title: "Lecturer",
      country: "Kenya",
      feedback:
        "The trainers did an excellent job, and the online learning platform was easy to navigate. I have gained necessary skills to guide me in the next peer review assignment. Thank you.",
    },
    {
      name: "RQ",
      title: "Biologist",
      country: "Ghana",
      feedback:
        "God bless the COPPHA team for putting up this course. I am very grateful for this opportunity and cannot wait to utilize my new skill.",
    },
  ];



  return (
    <>
      <HeaderImage image="/assets/images/backgrounds/coppha.jpg"   alt="COPPHA Header"
  showButton={true}
  buttonText="Explore"
  buttonLink="https://wacren.net/en/establishing-a-diamond-oa-publishing-ecosystem-for-public-health-research-in-africa-the-coalition-for-open-access-publishing-of-public-health-in-africa-coppha/" />
      <div className="max-w-6xl mx-auto p-4" id="coppha">
        <section className="mb-16">
          <h3 className="text-2xl font-semibold text-center mb-10">
            COPPHA'S CORE OBJECTIVES
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-[#F87171] text-white p-6 rounded-tl-none rounded-br-3xl rounded-tr-none rounded-bl-none">
              Supporting the growth and sustainability of Diamond Open Access
              publishing in Africa.
            </div>
            <div className="bg-[#FBBF24] text-white p-6 rounded-tr-none rounded-bl-3xl rounded-br-none rounded-tl-none">
              Reducing Inequalities In Research Access, Publication, And
              Dissemination.
            </div>
            <div className="bg-[#3B82F6] text-white p-6 rounded-bl-none rounded-tr-3xl rounded-tl-none rounded-br-none">
              Equipping African researchers with the skills and knowledge to
              participate effectively in peer review processes and building the
              capacity needed to support Diamond OA journals in Africa to
              enhance trust in their outputs.
            </div>
            <div className="bg-[#047857] text-white p-6 rounded-br-none rounded-tl-3xl rounded-tr-none rounded-bl-none">
              Building a Community of Practice on Open Access Publishing in
              Africa.
            </div>
          </div>
        </section>

        <section className="mb-16">
          <h3 className="text-2xl font-semibold text-center mb-10">
            EXPLORE COPPHA'S CORE TRAININGS
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div className="flex flex-col items-start bg-white rounded-lg">
              <img
                src="/assets/images/coppha/coppha-open-publishing-course.jpg"
                alt="COPPHA Open Publishing Course"
                className="rounded-lg mb-4 w-full h-auto"
              />
              <h4 className="font-bold text-md mb-2">
                COPPHA OPEN PUBLISHING COURSE (2025)
              </h4>
              <p className="text-sm text-gray-700 mb-2">
                A six-week MOOC held from January 13 to February 23, 2025, this
                course introduced researchers to open access publishing and peer
                review practices through structured weekly facilitation.
              </p>
              <Link
                to="/coppha/peer-review-course"
                className="text-green-700 text-sm font-semibold"
              >
                See all &nbsp; &gt;
              </Link>
            </div>

            <div className="flex flex-col items-start bg-white rounded-lg">
              <img
                src="/assets/images/coppha/coppha-peer-reviewing-course.png"
                alt="COPPHA Peer Reviewing Course"
                className="rounded-lg mb-4 w-full h-[19rem] object-cover"
              />
              <h4 className="font-bold text-md mb-2">
                COPPHA PEER REVIEWING COURSE (2024)
              </h4>
              <p className="text-sm text-gray-700 mb-2">
                The 2024 COPPHA Peer Reviewing Course was delivered by WACREN
                and Peoples-Praxis, key partners in the Coalition for Open
                Access Publishing of Public Health in Africa (COPPHA).
              </p>
              <Link
                to="/coppha/open-publishing-course"
                className="text-green-700 text-sm font-semibold"
              >
                See all &nbsp; &gt;
              </Link>
            </div>
          </div>
        </section>

        <section className="mb-12">
          <h3 className="text-2xl font-semibold text-center mb-6">
            PARTICIPANTS' FEEDBACK
          </h3>
          <div className="space-y-4">
            {feedbacks.map(({ name, title, country, feedback }, index) => (
              <div className="p-6 bg-gray-100 rounded-lg">
              <blockquote
                key={index}
                className="text-sm italic"
              >
                {feedback}
              </blockquote>
                  <p className="font-semibold text-foreground">
                    {name}, {title}, {country}:
                  </p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-12">
          <h3 className="text-2xl font-semibold text-center mb-6">
            COLLABORATING ORGANIZATIONS
          </h3>
          <CollaboratingCarousel />
        </section>

        <section className="mb-16">
          <h3 className="text-2xl font-semibold text-center mb-6">Frequently Asked Questions</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {faq.map(({question, answer}, index) => (
              <div key={index} className="bg-gray-100 p-6 rounded-lg text-sm">
                <p className="font-semibold text-foreground">{question}</p>
                <p>{answer}</p>
               </div>
            ))}
          </div>
        </section>

      </div>
    </>
  );
};

export default CopphaPage;
